import FormCard from './cardForm';
// 常量
import type { CardFormProps, CardFormActionType, } from './interface';
import './style.less';

export type { CardFormProps, CardFormActionType, };

export default FormCard;
